import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "_grid _grid-cols-1 _grid-cols-2--m _col-gap-5 _row-gap-5" }
const _hoisted_2 = { class: "gfu-hd gfu-hd--h3 _mb-2 _mt-3" }
const _hoisted_3 = ["format-key", "href"]
const _hoisted_4 = { key: 0 }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_base_icon = _resolveComponent("base-icon")
  const _component_localize = _resolveComponent("localize")
  const _component_box = _resolveComponent("box")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.sections, (section) => {
      return (_openBlock(), _createBlock(_component_box, {
        key: section.header
      }, {
        default: _withCtx(() => [
          _createVNode(_component_base_icon, {
            name: section.icon,
            size: "lg",
            class: "_mb-3 _tc--accent"
          }, null, 8 /* PROPS */, ["name"]),
          _createElementVNode("h3", _hoisted_2, _toDisplayString(section.header), 1 /* TEXT */),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(section.paragraphs, (paragraph) => {
            return (_openBlock(), _createElementBlock("div", {
              key: paragraph,
              class: "gfu-bt--b1"
            }, [
              (paragraph.links)
                ? (_openBlock(), _createBlock(_component_localize, {
                    key: 0,
                    tag: "span",
                    resource: paragraph.text
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paragraph.links, (link, index) => {
                        return (_openBlock(), _createElementBlock("a", {
                          key: `link-${index}`,
                          "format-key": `${index.toString()}`,
                          href: link.url,
                          class: "gfu-link gfu-link--accent _tdu",
                          target: "_blank",
                          rel: "noopener noreferrer"
                        }, _toDisplayString(link.text), 9 /* TEXT, PROPS */, _hoisted_3))
                      }), 128 /* KEYED_FRAGMENT */))
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["resource"]))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("p", null, _toDisplayString(paragraph.text), 1 /* TEXT */),
                    (paragraph.list)
                      ? (_openBlock(), _createElementBlock("ul", _hoisted_4, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(paragraph.list, (item) => {
                            return (_openBlock(), _createElementBlock("li", { key: item }, _toDisplayString(item), 1 /* TEXT */))
                          }), 128 /* KEYED_FRAGMENT */))
                        ]))
                      : _createCommentVNode("v-if", true)
                  ], 64 /* STABLE_FRAGMENT */))
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _: 2 /* DYNAMIC */
      }, 1024 /* DYNAMIC_SLOTS */))
    }), 128 /* KEYED_FRAGMENT */))
  ]))
}